/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function TruncateIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "truncate", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M5 12.5H20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M8.5 19.5L12.5 15.5L16.5 19.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M16.5 5.5L12.5 9.5L8.5 5.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(TruncateIcon);
export default ForwardRef;
//# sourceMappingURL=truncateIcon.js.map